"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const baseURL = '/role';
class Role {
    constructor(params = {}) {
        Object.assign(this, params);
        this.name = this.displayName;
    }
    static list(params) {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        return new Promise((resolve, reject) => {
            http.get(`${baseURL}/list?${$.param(params)}`)
                .toPromise()
                .then(response => response.json())
                .then(response => {
                let roles = response.map(role => new Role(role));
                resolve(roles);
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    toRoleOption() {
        return {
            id: this.id,
            name: this.displayName,
            fa: this.slug
        };
    }
    isUser() {
        return this.type === 'user';
    }
}
exports.Role = Role;
//# sourceMappingURL=role.js.map